import { TApplicationState } from 'shared/types/redux';

export function promoSelector(state: TApplicationState) {
  return state.promo.promo;
}
